import { OptionData } from "components/DesignSystem/Combobox/Combobox";

export const uniqueByValue = <T extends OptionData>(options: T[]): T[] => {
  const seen = new Set<string>();
  return options.filter((option) => {
    if (seen.has(option.value)) return false;
    seen.add(option.value);
    return true;
  });
};
